import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopunecabservice() {



const cardData =
{
  keyword: 'Goa to Pune Cab Service',

  heading: 'Lotus Cab: Goa to Pune Cab Service',

headingDescription:
  "Lotus Cabs provides reliable and affordable Goa to Pune Cab Service for family vacations, corporate travel, business meetings, airport transfers, student travel, holiday trips, sightseeing, and one-way or round-trip journeys. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup from any location in Goa, well-maintained vehicles, and a strong focus on safety and comfort, Lotus Cabs ensures a smooth, punctual, and hassle-free travel experience for every Goa to Pune journey.",


  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa's most famous beaches, known for its lively atmosphere, water sports, beach shacks, vibrant nightlife, and stunning sunsets. Visitors enjoy activities like parasailing, jet skiing, banana boat rides, delicious seafood, and live music, making it a must-visit destination for travelers of all ages."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach, often called the 'Queen of Beaches,' is Goa's largest and most popular beach. Surrounded by restaurants, cafés, shopping stalls, and resorts, it offers exciting water sports, golden sands, and a lively environment that attracts thousands of domestic and international tourists every year."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved 17th-century Portuguese fort overlooking the Arabian Sea. Famous for its historic lighthouse, impressive architecture, and breathtaking coastal views, the fort is one of Goa's most iconic landmarks and a favorite destination for history lovers and photographers."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site renowned for housing the sacred relics of St. Francis Xavier. Built in Baroque architectural style, the church is one of Goa's most significant religious monuments and attracts pilgrims and heritage enthusiasts from around the world."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India's tallest and most spectacular waterfalls, cascading through the lush forests of the Western Ghats. Visitors can enjoy thrilling jeep safaris, trekking adventures, and breathtaking natural scenery, especially during the monsoon season."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a historic Portuguese fort famous for its panoramic views of Vagator Beach and the Arabian Sea. Popularly recognized from the Bollywood movie 'Dil Chahta Hai,' the fort is a favorite spot for sightseeing, photography, and watching mesmerizing sunsets."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is renowned for its scenic coastline, vibrant flea market, beach parties, and laid-back atmosphere. Travelers visit to enjoy live music, delicious seafood, shopping for handicrafts, and spectacular sunset views along Goa's beautiful northern coastline."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach is one of South Goa's most picturesque beaches, celebrated for its calm waters, crescent-shaped shoreline, and peaceful surroundings. Visitors can enjoy kayaking, dolphin spotting, beachside cafés, yoga retreats, and relaxing stays in charming beachfront cottages."
    },
    {
        title: "Reis Magos Fort",
        description:
            "Reis Magos Fort is a beautifully restored Portuguese fort offering stunning views of the Mandovi River and Panaji city. Its historical exhibits, impressive architecture, and tranquil surroundings make it an excellent destination for history enthusiasts and cultural explorers."
    },
    {
        title: "Cruise on the Mandovi River",
        description:
            "A Mandovi River cruise is one of Goa's most popular experiences, featuring live Goan folk performances, music, dance, delicious cuisine, and breathtaking evening views. Whether enjoyed during sunset or at night, the cruise offers a memorable way to experience Goa's vibrant culture and scenic beauty."
    }
],

 "services": [
  {
    "name": "Goa to Pune Cab Service",
    "description": "Reliable Goa to Pune cab service offering safe and comfortable intercity travel with professional drivers and well-maintained vehicles for one-way and round-trip journeys."
  },
  {
    "name": "Goa to Pune Cab",
    "description": "Book a Goa to Pune cab for hassle-free long-distance travel with flexible pickup options, AC vehicles, and transparent pricing."
  },
  {
    "name": "Goa to Pune Taxi Service",
    "description": "Professional Goa to Pune taxi service for families, tourists, and corporate travelers with clean cars and experienced drivers."
  },
  {
    "name": "Goa to Pune Taxi",
    "description": "Convenient Goa to Pune taxi available for direct intercity transportation with comfortable seating and affordable fares."
  },
  {
    "name": "Goa to Pune Car Rental",
    "description": "Goa to Pune car rental service with sedan, SUV, and premium vehicle options suitable for personal and business travel."
  },
  {
    "name": "Goa to Pune One Way Cab",
    "description": "Affordable Goa to Pune one way cab service allowing passengers to pay only for the single-side journey without return charges."
  },
  {
    "name": "Goa to Pune Round Trip Cab",
    "description": "Flexible Goa to Pune round trip cab packages for business meetings, family vacations, and multi-day travel requirements."
  },
  {
    "name": "Goa to Pune Outstation Cab",
    "description": "Comfortable Goa to Pune outstation cab service designed for long-distance travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Goa to Pune Cab Booking",
    "description": "Easy Goa to Pune cab booking service with instant confirmation, multiple vehicle choices, and reliable customer support."
  },
  {
    "name": "Goa to Pune Online Cab Booking",
    "description": "Book your Goa to Pune taxi online with quick reservations, transparent pricing, and convenient pickup scheduling."
  },
  {
    "name": "Goa to Pune Private Taxi",
    "description": "Private taxi service from Goa to Pune offering exclusive travel experience with privacy, comfort, and flexible departure timings."
  },
  {
    "name": "Goa to Pune Sedan Cab",
    "description": "Comfortable Goa to Pune sedan cab service ideal for solo travelers, couples, and small families seeking economical travel."
  },
  {
    "name": "Goa to Pune Innova Cab",
    "description": "Spacious Goa to Pune Innova cab suitable for family trips and group travel with ample luggage space and premium comfort."
  },
  {
    "name": "Goa to Pune Innova Crysta",
    "description": "Premium Goa to Pune Innova Crysta service offering luxury seating and smooth highway performance for long-distance journeys."
  },
  {
    "name": "Goa to Pune Ertiga Cab",
    "description": "Affordable Goa to Pune Ertiga cab with comfortable seating for up to six passengers, ideal for family and leisure travel."
  },
  {
    "name": "Goa to Pune SUV Cab",
    "description": "Goa to Pune SUV cab service providing spacious interiors and comfortable travel for groups and extra luggage requirements."
  },
  {
    "name": "Goa to Pune Airport Taxi",
    "description": "Reliable Goa to Pune airport taxi service with timely pickup from Dabolim and Mopa Airport for direct transfers to Pune."
  },
  {
    "name": "Goa to Pune Affordable Cab",
    "description": "Budget-friendly Goa to Pune affordable cab service with competitive fares and quality travel experience."
  },
  {
    "name": "Goa to Pune Luxury Cab",
    "description": "Premium Goa to Pune luxury cab service featuring high-end vehicles and superior comfort for business and VIP travelers."
  },
  {
    "name": "Goa to Pune Cab Fare",
    "description": "Get transparent Goa to Pune cab fare details with clear pricing based on distance, vehicle type, tolls, and driver allowances."
  },
  {
    "name": "Goa to Pune Taxi Fare",
    "description": "Affordable Goa to Pune taxi fare plans with upfront pricing and no hidden charges for long-distance travel."
  },
  {
    "name": "Goa to Pune Cab Price",
    "description": "Check Goa to Pune cab price options for sedans, SUVs, and premium vehicles with flexible travel packages."
  },
  {
    "name": "Best Goa to Pune Cab Service",
    "description": "Best Goa to Pune cab service offering professional drivers, clean vehicles, timely pickup, and exceptional customer support."
  },
  {
    "name": "Goa to Pune Family Cab",
    "description": "Comfortable Goa to Pune family cab service with spacious vehicles and safe travel arrangements for family vacations."
  },
  {
    "name": "Goa to Pune AC Cab",
    "description": "Travel comfortably with Goa to Pune AC cab service featuring air-conditioned vehicles and experienced chauffeurs."
  }
],

"tableData": [
  ["Goa to Pune Cab Service", "Goa to Pune Cab"],
  ["Goa to Pune Taxi Service", "Goa to Pune Taxi"],
  ["Goa to Pune Car Rental", "Goa to Pune One Way Cab"],
  ["Goa to Pune Round Trip Cab", "Goa to Pune Outstation Cab"],
  ["Goa to Pune Cab Booking", "Goa to Pune Online Cab Booking"],
  ["Goa to Pune Private Taxi", "Goa to Pune Sedan Cab"],
  ["Goa to Pune Innova Cab", "Goa to Pune Innova Crysta"],
  ["Goa to Pune Ertiga Cab", "Goa to Pune SUV Cab"],
  ["Goa to Pune Airport Taxi", "Goa to Pune Affordable Cab"],
  ["Goa to Pune Luxury Cab", "Goa to Pune Cab Fare"],
  ["Goa to Pune Taxi Fare", "Goa to Pune Cab Price"],
  ["Best Goa to Pune Cab Service", "Goa to Pune Family Cab"],
  ["Goa to Pune AC Cab", ""]
],

"whychoose": [
  {
    "WhyChooseheading": "Safe Long-Distance Travel",
    "WhyChoosedescription": "Experienced drivers ensure secure and comfortable highway travel from Goa to Pune."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Affordable per km fares with complete pricing transparency and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Options",
    "WhyChoosedescription": "Flexible one-way and round-trip cab services according to your travel requirements."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Choices",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles for your journey."
  },
  {
    "WhyChooseheading": "Airport & Hotel Pickup",
    "WhyChoosedescription": "Convenient pickup services available from Goa Airport, railway station, and hotels."
  },
  {
    "WhyChooseheading": "Comfortable AC Cabs",
    "WhyChoosedescription": "Well-maintained and sanitized air-conditioned vehicles for a relaxing ride."
  },
  {
    "WhyChooseheading": "Professional Drivers",
    "WhyChoosedescription": "Skilled drivers familiar with coastal and ghat routes ensure a smooth journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock booking assistance and instant confirmation for your travel needs."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Goa to Pune cab service?',
    answer: 'Yes, Lotus Cab offers reliable Goa to Pune cab services for both one-way and round-trip travel with experienced drivers and comfortable vehicles.',
  },
  {
    question: 'What is the distance between Goa and Pune by cab?',
    answer: 'The distance between Goa and Pune is approximately 450 km and the travel time is around 8 to 10 hours depending on traffic and route conditions.',
  },
  {
    question: 'What are the charges for Goa to Pune cab booking?',
    answer: 'Cab charges vary depending on the vehicle selected, travel date, and trip type. Lotus Cab offers affordable pricing with transparent billing.',
  },
  {
    question: 'Can I book a one-way Goa to Pune cab?',
    answer: 'Yes, Lotus Cab provides affordable one-way Goa to Pune cab services, allowing passengers to pay only for the drop journey.',
  },
  {
    question: 'Which vehicles are available for Goa to Pune travel?',
    answer: 'We offer Sedan cars like Dzire and Etios, as well as Ertiga, Innova Crysta, and SUVs for family and group travel.',
  },
  {
    question: 'Does Lotus Cab provide Goa Airport pickup for Pune?',
    answer: 'Yes, we offer direct pickup services from Goa Airport, hotels, and other locations for convenient travel to Pune.',
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are charged separately as per actuals and are clearly communicated before booking confirmation.',
  },
  {
    question: 'Is night travel available from Goa to Pune?',
    answer: 'Yes, Lotus Cab provides safe night travel options with experienced drivers for long-distance journeys.',
  },
  {
    question: 'Can I book a round trip from Goa to Pune and back?',
    answer: 'Yes, we offer flexible round-trip packages for customers planning return travel between Goa and Pune.',
  },
  {
    question: 'How can I book Goa to Pune Cab Service with Lotus Cab?',
    answer: 'You can book your cab by sharing your pickup location, travel date, number of passengers, and preferred vehicle to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Naik',
    feedback: 'Booked Lotus Cab for our Goa to Pune return journey after vacation. The driver was professional and the trip was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Excellent Goa to Pune cab service by Lotus Cab. Clean vehicle, timely pickup, and transparent pricing made our journey hassle-free.',
    rating: 5,
  },
];










































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Goa to Pune Cab Service",
"image": "https://lotuscab.com/assets/images/goa-to-pune-cab-service.jpg",
"description": "Book Goa to Pune Cab Service with Lotus Cab for comfortable, reliable, and affordable outstation travel. Enjoy one way and round trip taxi services with sedan, Innova, Innova Crysta, Ertiga, and SUV cabs available for airport transfers, family trips, and business travel with 24x7 service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/goa-to-pune-cab-service"
}
};








  return (
    <div>
      
<Helmet>
  <title>Goa to Pune Cab Service | One Way & Outstation Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Goa to Pune Cab Service with Lotus Cab for safe and comfortable outstation travel. One way, round trip, airport taxi, and luxury AC cab services available with professional drivers and affordable fares."
/>

<meta
 name="keywords"
 content="Goa to Pune Cab Service, Goa to Pune Cab, Goa to Pune Taxi Service, Goa to Pune Taxi, Goa to Pune Car Rental, Goa to Pune One Way Cab, Goa to Pune Round Trip Cab, Goa to Pune Outstation Cab, Goa to Pune Cab Booking, Goa to Pune Online Cab Booking, Goa to Pune Private Taxi, Goa to Pune Sedan Cab, Goa to Pune Innova Cab, Goa to Pune Innova Crysta, Goa to Pune Ertiga Cab, Goa to Pune SUV Cab, Goa to Pune Airport Taxi, Goa to Pune Affordable Cab, Goa to Pune Luxury Cab, Goa to Pune Cab Fare, Goa to Pune Taxi Fare, Goa to Pune Cab Price, Best Goa to Pune Cab Service, Goa to Pune Family Cab, Goa to Pune AC Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopunecabservice;